import {
    AfterViewInit,
    ApplicationRef,
    ChangeDetectionStrategy,
    ChangeDetectorRef,
    Component,
    ElementRef,
    EventEmitter,
    Input,
    OnDestroy,
    OnInit,
    Output,
    ViewChild,
    inject,
    input,
    signal,
} from '@angular/core';
import { NavigationEnd, NavigationStart, Router } from '@angular/router';
import { toSignal } from '@angular/core/rxjs-interop';
import { filter, Subscription } from 'rxjs';
import { AppGlobalsModule } from 'src/app/app-globals.module';
import { DailyTimeHeader } from 'src/app/calendar/calendar-service/calendar.service';
import { BreakPointSizeService } from 'src/app/core/services/break-point-size/break-point-size.service';
import { I18nService } from 'src/app/core/services/i18n/i18n.service';
import { SiteLocations, UrlAddressService } from 'src/app/core/services/url-address/url-address.service';
import { UtilService } from 'src/app/core/services/util/util.service';
import { UserService } from 'src/app/user/user.service';
import { BannerTop, HeaderMode, SiteHeaderService } from '../site-header.service';
import { btnLink } from 'src/app/shared/helpers/btn-link/btn-link.model';

@Component({
    selector: 'sticky-header',
    templateUrl: './sticky-header.component.html',
    styleUrls: ['./sticky-header.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false,
})
export class StickyHeaderComponent implements OnInit, AfterViewInit, OnDestroy {
    breakPointSizeService = inject(BreakPointSizeService);
    private _siteHeaderService = inject(SiteHeaderService);
    private _util = inject(UtilService);
    private _i18n = inject(I18nService);
    private _userService = inject(UserService, { optional: true })!;
    private _appRef = inject(ApplicationRef);
    urlAddress = inject(UrlAddressService);
    changeDetector = inject(ChangeDetectorRef);
    private _router = inject(Router);

    @Input() bannerTop!: BannerTop;
    public activeLocation = input<SiteLocations>();
    @Input() headerMode!: HeaderMode;
    @Input() dailyTimeHeader: DailyTimeHeader | undefined;
    @Input() isAngularApp!: boolean;
    @Input() isAtTop!: boolean;
    // @Input() isAdLoaded: boolean;
    @Input() isHeaderFixed!: boolean;
    @Input() hebrewDate = '';
    @Input() dailyDonor = '';
    @Input() omer = '';

    @Output() toggleMenu = new EventEmitter();
    // eslint-disable-next-line @angular-eslint/no-output-on-prefix
    @Output() onSearchClick = new EventEmitter();
    @Output() toggleSocialShareBox = new EventEmitter<boolean>();
    public isAngularPage: boolean = false;
    public HeaderMode = HeaderMode;
    public SiteLocations = SiteLocations;
    public selfAreaI18N: string = $localize`:@@selfArea:איזור אישי`;
    public searchPlaceholder: string = $localize`:@@what-interests-you?:מה מעניין אותך?`;
    public mirrorLink: string = $localize`:@@mirrorWebAddress://www.yeshiva.co`;
    public dayTimes: string = $localize`:@@dayTimes:זמני היום` + ' ' + $localize`:@@in:ב`;
    public moreTimes: string = $localize`:@@more-times-place:לזמנים במקומות נוספים`;
    public isHeb: boolean;
    public isServer = AppGlobalsModule.isServer;
    public badgeSize: 'small' | 'medium' = 'small';
    public otherLangLink = toSignal(this.urlAddress.getOtherLangLink$(), { initialValue: '' });

    // userData: any;
    public userNotifications = 0;
    /**
     * The nihul-login icon: shown only to logged-out users whose browser remembers a
     * nihul logon address (nihul staff who logged in here before) - clicking it opens
     * the nihul logon overlay directly, without exposing the address anywhere.
     */
    public showNihulLogin = signal(false);
    /** the counterpart: a logout icon while connected as a nihul (internal) user */
    public showNihulLogout = signal(false);
    /** a "ניהול" link (next to תרומות) while connected as any nihul user (staff or rabbi) */
    public showNihulHome = signal(false);
    /** where the ניהול link lands - rabbi-only accounts go straight to their area */
    public nihulHomeLink = signal('/nihul');
    @ViewChild('stickyHeaderRef') stickyHeaderEl!: ElementRef;

    constructor() {
        this.isHeb = this._i18n.langIsHeb();
    }

    ngOnInit(): void {
        this.isAngularPage = this.urlAddress.ifAngularPage();
        this._isHeb = this._i18n.langIsHeb();
        this._langBaseUrl = this._i18n.getLangBaseUrl(true);
    }
    private _subscriptions: Subscription[] = [];

    public groupsLinks = new Map<string, btnLink[]>();
    private _isHeb: boolean = false;
    private _langBaseUrl: string = '';

    ngAfterViewInit(): void {
        // Remy removs it since he doesn't understand how it effect the page,   might be a mistake tho.\
        // this._subscriptions.push(
        //     this._siteHeaderService.getHeaderMode$().subscribe(_ => {
        //         setTimeout(() => {
        //             this._siteHeaderService.setHeightHeaderSticky(this.stickyHeaderEl?.nativeElement.offsetHeight || 50);
        //             if (AppGlobalsModule.isDevelopment) {
        //                 console.log('_siteHeaderService.setHeightHeaderSticky', this.stickyHeaderEl?.nativeElement.offsetHeight);
        //             }
        //         }, AppGlobalsModule.isServer ? 0 : 50);
        //     })
        // );

        // Need user data to initiate user badget notification

        this.groupsLinks = this.getGroupsLinks(); //prevent show the links before the css loaded

        if (!this.isServer) {
            //follow every login/logout (including a nihul-overlay login and the
            //focus-time transfer-cookie sync); subscribed first so nothing below can
            //prevent the registration
            this._subscriptions.push(
                this._userService.getUser().subscribe(() => {
                    this._updateNihulIcons();
                }),
            );
            //initial state once the user bar settled (logged-out users never get a
            //callback emission, so this is what shows the login icon for them)
            this._userService.userReady(false).then(() => {
                this._updateNihulIcons();
            });
            this._subscriptions.push(
                this._userService.getUserDataSummaryObservable().subscribe({
                    next: (userData) => {
                        if (userData != null) {
                            // this.userData = userData; // Commented because we don't need it, stayed here for reference.
                            this.userNotifications = userData.server?.answers + userData.server?.new_alerts_on_replies;
                            // If user has many notifications, we want to show only 99+
                            if (this.userNotifications > 99) {
                                this.userNotifications = 99;
                            }

                            // If user has two digits, we want to show the badge in a bigger size
                            if (this.userNotifications > 9) {
                                this.badgeSize = 'medium';
                            }
                            this.changeDetector.markForCheck();
                        }
                    },
                }),
            );
        }
    }

    ngOnDestroy(): void {
        this._util.unsubscribe(this._subscriptions);
        if (this.toggleMenu) {
            this.toggleMenu.unsubscribe();
        }
        if (this.onSearchClick) {
            this.onSearchClick.unsubscribe();
        }
        if (this.toggleSocialShareBox) {
            this.toggleSocialShareBox.unsubscribe();
        }
    }

    private _updateNihulIcons(): void {
        let hasLogonAddress = false;
        try {
            hasLogonAddress = !!localStorage.getItem('nihulLogonUrl');
        } catch (e) {
            //storage unavailable - no icon
        }
        const connected = this._userService.userConnected();
        const isInternal = this._userService.isInternal();
        this.showNihulLogin.set(hasLogonAddress && !connected);
        this.showNihulLogout.set(connected && isInternal);
        //rabbi accounts (nihulUser without internal access) get the link too, pointed at
        //their own area by nihulEntryLink
        this.showNihulHome.set(connected && (isInternal || this._userService.nihulUser()));
        this.nihulHomeLink.set(this._userService.nihulEntryLink());
        this.changeDetector.markForCheck();
        //zoneless build: these run from legacy UserBar callbacks, outside angular's
        //reactive context - signal writes there don't schedule a tick on the production
        //build (same incident as the hofeshLimud nihul button), so schedule one
        try {
            this._appRef.tick();
        } catch (e) {
            //already inside change detection - the write is picked up anyway
        }
    }

    /** opens the nihul logon overlay (UserBar) from the remembered address */
    public openNihulLogin(): void {
        const userGlobal = (window as { user?: { nihulLogin?: () => boolean } }).user;
        userGlobal?.nihulLogin?.();
    }

    /** logs out of the nihul AND the site (they are synced) and returns to this page */
    public openNihulLogout(): void {
        window.location.href = '/users/LogOff/';
    }

    public getGroupsLinks(): Map<string, btnLink[]> {
        return new Map<string, btnLink[]>([
            [
                'midrash-links',
                [
                    { name: $localize`:@@lessons:שיעורים`, link: '/midrash/filter' },
                    { name: $localize`:@@shorts:שורטס`, link: '/midrash/shorts' },
                    {
                        name: $localize`:@@parashatHashavua:פרשת השבוע`,
                        link: `/tags/${$localize`:@@parashatHashavua:פרשת השבוע`}`,
                    },
                    { name: $localize`:@@series:סדרות`, link: '/midrash/series' },
                    { name: $localize`:@@psakiDin:פסקי דין`, link: '/psakim' },
                    { name: $localize`:@@library:ספריה`, link: '/sifria' },
                    { name: $localize`:@@testYourself:בחן את עצמך`, link: '/test' },
                    {
                        name: $localize`:@@pnineiHalacha:פניני הלכה`,
                        link: '/midrash/category/149',
                    },
                ],
            ],
            [
                'ask-links',
                [
                    {
                        name: $localize`:@@questions-repository:מאגר השאלות`,
                        link: '/ask/filter',
                    },
                    { name: $localize`:@@askYourQuestion:שליחת שאלה`, link: '/ask/ask' },
                    {
                        name: $localize`:@@familyPurity:בית הוראה לטהרת המשפחה`,
                        link: '/ask/askhoraa',
                        queryParams: { inner: 2 },
                    },
                    {
                        name: $localize`:@@daily-halacha:הלכה יומית`,
                        link: '/ask/halacha',
                    },
                ],
            ],

            [
                'calendar-links',
                [
                    { name: $localize`:@@shabatTimes:זמני כניסת השבת`, link: '/calendar/shabbattimes' },
                    { name: $localize`:@@daily-times:זמני היום`, link: '/calendar/timesday' },
                    { name: $localize`:@@monthTimes:זמני החודש`, link: '/calendar/timestable' },
                    { name: $localize`:@@moladot:זמן המולד`, link: '/calendar/moladot/' },
                    { name: $localize`:@@memorial-calendar:לוח ימי זכרון`, link: '/events/memorial', isAngularPage: true },
                    { name: $localize`:@@events:אירועים`, link: '/events/activities' },
                    { name: $localize`:@@bar-mitzva-calculator:מחשבון בר מצוה`, link: '/calendar/bmcal' },
                    {
                        name: $localize`:@@date-converter:ממיר תאריכים עברי לועזי`,
                        link: '/calendar/dateconverter',
                    },

                    {
                        name: $localize`:@@principles-times:עקרונות זמני היום`,
                        link: '/calendar/timeprinciples',
                    },
                    {
                        name: $localize`:@@timesOnYourSite:זמני היום באתרך`,
                        link: '/generalpages/externalcontent',
                        queryParams: { the_content: 'time' },
                    },
                ],
            ],
            [
                'viki-links',
                [
                    {
                        name: $localize`:@@talmudicEncyclopedia:האנציקלופדיה התלמודית`,
                        link: (this._isHeb ? '' : this._langBaseUrl) + '/wiki/index.php/ויקישיבה:אנציקלופדיה_תלמודית',
                    },
                    {
                        name: $localize`:@@parsheni:פרשני`,
                        link: (this._isHeb ? '' : this._langBaseUrl) + '/wiki/index.php/פרשני:עמוד_ראשי',
                    },
                    {
                        name: $localize`:@@darsheni:דרשני`,
                        link: (this._isHeb ? '' : this._langBaseUrl) + '/wiki/index.php/דרשני:עמוד_ראשי',
                    },
                    {
                        name: $localize`:@@signup:הרשמה`,
                        link: (this._isHeb ? '' : this._langBaseUrl) + '/wiki/index.php/מיוחד:הרשמה_לחשבון?returnto=עמוד_ראשי',
                    },
                    {
                        name: $localize`:@@random-page:דף אקראי`,
                        link: (this._isHeb ? '' : this._langBaseUrl) + '/wiki/index.php/מיוחד:אקראי',
                    },
                    {
                        name: $localize`:@@dictionary:מילון`,
                        link: (this._isHeb ? '' : this._langBaseUrl) + '/wiki/index.php/מילון:ראשי',
                    },
                ],
            ],
        ]);
    }
}
